import { useApplicationContext } from '../../utils/applicationContext/applicationContext';

export const useConsultantChatHost = () => {
  const { config } = useApplicationContext();

  return config.get<string>('builderChatHost') ?? '';
};
